import angular from 'angular'

import { SyncManager } from '../managers/sync-manager'

/**
 * Initialises the syncManager.
 *
 * @module webregister.resolvers.syncManagerResolver
 */
angular
  .module('webregister.resolvers')
  .factory('syncManagerResolver', function (syncManager: SyncManager) {
    // eslint-disable-next-line compat/compat -- rule is incorrectly flagging this as the Background Synchronization API Sync Manager
    return syncManager.init()
  })
